// extracted by mini-css-extract-plugin
export var header = "_am-0";